import React from 'react';

// Components
import FormattedMessageV2 from '@/views/components/i18n/FormattedMessageV2';
import { UpsertForm } from './components/UpsertForm';

// Types
import HistoricalScenario from '@/types/historical-scenario';

interface EditBodyProps {
  customScenario: HistoricalScenario;
  i18nBasePath: string;
  isLoading?: boolean;
  onClose: () => void;
  onSubmit: (scenario: Partial<HistoricalScenario>) => void;
}

export const EditBody: React.FC<EditBodyProps> = ({ customScenario, i18nBasePath, isLoading = false, onClose, onSubmit }) => (
  <div className="custom-scenario">
    <FormattedMessageV2 className="custom-scenario-description" toLocalize={`${i18nBasePath}.Description`} />
    <UpsertForm customScenario={customScenario} isLoading={isLoading} onClose={onClose} onSubmit={onSubmit} />
  </div>
);
